import React, { useState } from 'react'
import Button from '../../../atoms/Button/Button'
import { PiCaretLeftBold } from "react-icons/pi";
import { PiCaretRightBold } from "react-icons/pi";
import { colors } from '../../../../assets/colors/colors';
import { useTranslation } from 'react-i18next';

export default function Videosprojector({videos}) {
    const [currentIndex, setCurrentIndex] = useState(0)
    const { t, i18n } = useTranslation();
    const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";

    
    // const videos = [
    //     { src: "https://www.w3schools.com/html/mov_bbb.mp4", title: "وزارة الثقافة تدرج أسماء شهداء الاطقم الطبية بمشروع عاش هنا تخليدا لدورهم ا الوطني" },
    //     { src: "https://www.w3schools.com/html/movie.mp4", title: "Sample Video 2" },
    //     { src: "https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4", title: "Sample Video 3" },
    //   ];
      
    const goToNext = () => setCurrentIndex((currentIndex + 1) % videos?.length);
    const goToPrevious = () => setCurrentIndex((currentIndex - 1 + videos?.length) % videos?.length);

    // console.log("videos-------------->",videos)
    // console.log("im gere")
    const videooo="https://www.youtube.com/watch?v=-M_YQWA2hUM"

      // Function to check if it's a YouTube link and convert it to an embed URL
      const getYouTubeEmbedURL = (url) => {
        const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
        const match = url.match(youtubeRegex);
        return match ? `https://www.youtube.com/embed/${match[1]}` : url;
    };



    const currentVideo = videos ? videos[currentIndex] : null;
    const isYouTube = currentVideo?.link?.includes("youtube.com") || currentVideo?.link?.includes("youtu.be");
    const videoSrc = isYouTube ? getYouTubeEmbedURL(currentVideo.link) : currentVideo?.link;
    const videoTitle = isArabic
      ? currentVideo?.titleA
      : currentVideo?.titleE;

  return (
    <div className='relative flex flex-col justify-start items-center h-full w-[368px] md:w-[978px] lg:w-[1168px] bg-rd-600'>

        {/* the video itself */}
        {videos === undefined || videos?.length!==0?
        <div className=' flex flex-row justify-evenly items-center md:h-[417px] w-[268px] md:w-[858px] lg:w-[968px] bg-rd-400'>
                    <div >
                            <Button arrow_left onClick={goToNext}>{<PiCaretLeftBold style={{color: colors[1]}}/>}</Button>
                    </div>
                  

                        <div className="w-[268px] md:w-[968px] h-[167px] md:h-[417px] rounded-[16px] border-2 border-amber overflow-hidden ">
                              {isYouTube ?(
                              <iframe
                                // src={videos?videos[currentIndex]?.link:null}
                                src={videoSrc}
                                title={videoTitle}
                                frameBorder="0"
                                className="w-full h-full rounded-[16px]"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                              ):(
                                <video 
                                // src={currentVideo?.link} 
                                src={videoSrc} 
                                className="w-full h-full rounded-[16px]" 
                                controls 
                            />
                              )}



                        </div>


                    <div >

                            <Button arrow_right onClick={goToPrevious}>{<PiCaretRightBold style={{color: colors[1]}}/>}</Button>
                    </div>
            
        </div>
            :

            <div className="text-amber font-cairo-semibold text-xl md:text-3xl">{t("home.videos.empty")}</div>
            
        }
        <div className="font-tajawal-regular font-semibold line-clamp-2 mt-[8px] w-[268px] md:w-[968px] text-start">{videoTitle || currentVideo?.fileName || t("common.noData")}</div>


    </div>
  )
}
